// extracted by mini-css-extract-plugin
export default {"spinner":"styles_spinner__QrPWj","spin":"styles_spin__x7NHm","fullScreen":"styles_fullScreen__fsqNW","hidden":"styles_hidden__EeS2F"};